export default [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/rani/HomeView.vue'),
  },
  {
    path:'/create-campaign',
    name:'create-campaign',
    component:() => import('@/views/rani/CreateCampaign.vue')
  },
  {
    path:'/insert-invoice',
    name:'insert-invoice',
    component:() => import('@/views/rani/InsertInvoice.vue')
  },
  {
    meta: { title: 'menu.editCampaign' },
    path:'/campaigns/edit/:id',
    name:'edi-campaign',
    component:() => import('@/views/rani/EditCampaign.vue')
  },
  {
    meta: { title: 'menu.ratioCoin' },
    path:'/ratio-coin',
    name:'ratio-coin',
    component:() => import('@/views/rani/RatioCoins.vue')
  },
]
